import { render, staticRenderFns } from "./relevantToMe.vue?vue&type=template&id=69ff986c&scoped=true"
import script from "./relevantToMe.vue?vue&type=script&lang=js"
export * from "./relevantToMe.vue?vue&type=script&lang=js"
import style0 from "./relevantToMe.vue?vue&type=style&index=0&id=69ff986c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ff986c",
  null
  
)

export default component.exports